import { render, staticRenderFns } from "./SmartReceper.vue?vue&type=template&id=35d7de66&scoped=true&"
import script from "./SmartReceper.vue?vue&type=script&lang=js&"
export * from "./SmartReceper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d7de66",
  null
  
)

export default component.exports